import React, { useState } from 'react';
import AdminDashboard from './AdminDashboard';
import Manager2Dashboard from './Manager2Dashboard';
import EmployeeDashboard from './EmployeeDashboard';
import Manager1Dashboard from './Manager1Dashboard';
import DirectorDashboard from './DirectorDashboard';
import AccountsDashboard from './AccountsDashboard';

function Login({ onLogin }) {
  const [mobile, setMobile] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await fetch('/api/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ mobile, password })
      });
      const data = await res.json();
      if (data.token) {
        localStorage.setItem('token', data.token);
        localStorage.setItem('user', JSON.stringify(data.user));
        onLogin(data.user);
      } else {
        setError(data.message || 'Login failed');
      }
    } catch (err) {
      setError('Server error. Please try again.');
    }
    setLoading(false);
  };

  return (
    <div style={{minHeight:'100vh',background:'linear-gradient(135deg,#1a365d 0%,#2b6cb0 100%)',display:'flex',alignItems:'center',justifyContent:'center'}}>
      <div style={{background:'white',padding:'40px',borderRadius:'16px',boxShadow:'0 20px 60px rgba(0,0,0,0.3)',width:'100%',maxWidth:'400px'}}>
        <div style={{textAlign:'center',marginBottom:'32px'}}>
          <div style={{width:'60px',height:'60px',background:'#1a365d',borderRadius:'12px',display:'flex',alignItems:'center',justifyContent:'center',margin:'0 auto 16px',fontSize:'24px'}}>🏦</div>
          <h1 style={{color:'#1a365d',fontSize:'26px',fontWeight:'bold',margin:'0'}}>AH Chits</h1>
          <p style={{color:'#718096',marginTop:'6px',fontSize:'14px'}}>Namma AH Chits Pvt Ltd</p>
        </div>
        <form onSubmit={handleLogin}>
          <div style={{marginBottom:'20px'}}>
            <label style={{display:'block',marginBottom:'6px',color:'#4a5568',fontWeight:'500',fontSize:'14px'}}>Mobile Number</label>
            <input type="text" value={mobile} onChange={e=>setMobile(e.target.value)} placeholder="Enter 10-digit mobile"
              style={{width:'100%',padding:'12px 14px',border:'2px solid #e2e8f0',borderRadius:'8px',fontSize:'16px',boxSizing:'border-box',outline:'none'}} required />
          </div>
          <div style={{marginBottom:'24px'}}>
            <label style={{display:'block',marginBottom:'6px',color:'#4a5568',fontWeight:'500',fontSize:'14px'}}>Password</label>
            <input type="password" value={password} onChange={e=>setPassword(e.target.value)} placeholder="Enter password"
              style={{width:'100%',padding:'12px 14px',border:'2px solid #e2e8f0',borderRadius:'8px',fontSize:'16px',boxSizing:'border-box',outline:'none'}} required />
          </div>
          {error && <div style={{background:'#fff5f5',color:'#c53030',padding:'10px 14px',borderRadius:'8px',marginBottom:'16px',fontSize:'14px',border:'1px solid #fed7d7'}}>{error}</div>}
          <button type="submit" disabled={loading}
            style={{width:'100%',padding:'13px',background: loading?'#a0aec0':'#1a365d',color:'white',border:'none',borderRadius:'8px',fontSize:'16px',fontWeight:'600',cursor: loading?'not-allowed':'pointer'}}>
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default function App() {
  const [user, setUser] = useState(() => {
    const u = localStorage.getItem('user');
    return u ? JSON.parse(u) : null;
  });

  const handleLogin = (userData) => setUser(userData);
  const handleLogout = () => { localStorage.clear(); setUser(null); };

  if (!user) return <Login onLogin={handleLogin} />;

  if (user.role === 'admin') return <AdminDashboard user={user} onLogout={handleLogout} />;
  if (user.role === 'manager2') return <Manager2Dashboard user={user} onLogout={handleLogout} />;
  if (user.role === 'director1' || user.role === 'director2') return <DirectorDashboard user={user} onLogout={handleLogout} />;
  if (user.role === 'employee') return <EmployeeDashboard user={user} onLogout={handleLogout} />;
  if (user.role === 'manager1') return <Manager1Dashboard user={user} onLogout={handleLogout} />;
  if (user.role === 'accounts') return <AccountsDashboard user={user} onLogout={handleLogout} />;

  return (
    <div style={{padding:'40px',textAlign:'center'}}>
      <h2>Welcome {user.role}</h2>
      <p>Dashboard for your role is coming soon!</p>
      <button onClick={handleLogout} style={{padding:'10px 20px',background:'#e53e3e',color:'white',border:'none',borderRadius:'8px',cursor:'pointer'}}>Logout</button>
    </div>
  );
}
